import merge from 'lodash/merge'
import isNil from 'lodash/isNil'
import type { Product } from '@ztechapps/common.contract'
import { ProductStatusEnum, ProductTypeEnum } from '@ztechapps/common.contract'
import { generateId } from '@ztechapps/common.utils'

/** Default UOM ID for "Each" - matches seed data in migration */
export const DEFAULT_UOM_ID = 'uom_EACH'

export function createDefault(newValue?: Partial<Product>) {
  const defaultUom = { _id: DEFAULT_UOM_ID }

  const defaultValue = {
    inStock: isNil(newValue?.inStock) ? true : newValue?.inStock,
    name: newValue?.name ?? 'Handy new product name',
    code: newValue?.code ?? `CODE-${generateId(3)}`,
    price: newValue?.price ?? 1,
    status: newValue?.status ?? ProductStatusEnum.Draft,
    coverImage:
      newValue?.coverImage ??
      'https://res.cloudinary.com/tmmshauler/image/upload/v1617695508/panelpunches/prod-images-nopc/no-product-image.jpg',
    fullDescription: newValue?.fullDescription ?? ``,
    summary:
      newValue?.summary ??
      'Information about the product so the customer get easily know the overview of this product.',
    harmonizedTariffCode: '8207.30.3020',
    productType: ProductTypeEnum.Inventory,
    baseUom: defaultUom,
    orderUom: defaultUom,
    orderConversionFactor: 1,
    purchaseUom: defaultUom,
    purchaseConversionFactor: 1,
    workOrderUom: defaultUom,
    workOrderConversionFactor: 1,
    unitOfMeasurePrecision: 0,
  } as Partial<Product>

  return merge({}, defaultValue, newValue) as Product
}
